import { Yup } from "@pharmupp/p3-front-commons"

export const conditionsSchema = Yup.object({
  conditions: Yup.string().nullable(),
})
